module.exports = __webpack_public_path__ + "static/media/matnrrd_1-645w.956fcc8a.png";